import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logPostInfo, logging } from '../../actions/log';
import { CONTEXT } from '../../config';
import { getSearchRecommend } from '../../actions/search';
import AButton from '../AButton/AButton';
import Rate from '../Rate/Rate';
import styles from './NSALineCard.module.less';
import gift from '../../static/search_gift.svg';
import reco from '../../static/search_reco.svg';
import sale from '../../static/search_sale.png';
import essence from '../../static/search_essence.png';
import MyLink from '../Link/Link';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const installedSoftInit = useSelector(selectInstalledSoft);
  const logInfoData = useSelector(selectLogInfo);

  const handleSoftBtn = useCallback(
    _soft => {
      const found = installedSoftInit.find(soft_ => soft_.packageName === _soft.packageName);
      if (!found) {
        dispatch(
          getSearchRecommend({
            softInfo: _soft.packageName,
            androidType: _soft.androidType || 1,
            source: logInfo.source,
          }),
        );
      }
    },
    [dispatch, installedSoftInit],
  );

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'LineCard_err';
    dispatch(
      logPostInfo({
        ...logInfoData,
        source,
      }),
    );
  }, [dispatch]);

  // 专题商品文字链接
  const handleClickAD = () => {
    // 专题商品文字链接
    dispatch(
      logging({
        category: 'C',
        action: 'Search_Buy_Text',
        label: '',
        param2: {
          source: logInfo ? logInfo.source : 'LineCard_err',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
          softId: soft.softID,
          softType: soft.androidType || 0,
          targetContent: soft && soft.activityList && soft.activityList[0].targetContent,
          targetType: soft && soft.activityList && soft.activityList[0].targetType,
        },
      }),
    );

    dispatch(
      logPostInfo({
        ...logInfoData,
        source: `${logInfo && logInfo.source}||Search_Activity`,
      }),
    );
  };

  // 搜索结果页-商品活动文字链展现
  useEffect(() => {
    if (soft && soft.activityList && soft.activityList[0]) {
      if (soft.activityList[0].targetType === '11') {
        dispatch(
          logging({
            category: 'I',
            action: 'Search_Buy_Text',
            label: '',
            param2: {
              source: logInfo ? logInfo.source : 'LineCard_err',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              search_type: logInfoData.search_type,
              search_word: logInfoData.search_word,
              softId: soft.softID,
              softType: soft.androidType || 0,
              targetContent: soft && soft.activityList && soft.activityList[0].targetContent,
              targetType: soft && soft.activityList && soft.activityList[0].targetType,
            },
          }),
        );
      }
    }
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.card_content}>
        <Link
          to={{
            pathname: `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${soft.bizInfo ||
              '{}'}`,
          }}
          onClick={() => {
            handleSoftCard(soft);
          }}
        >
          <div className={styles.img_container}>
            <img className={styles.app_img} src={soft.logoFile} alt="" />
            <div className={styles.alogo} />
            {soft.hasGiftBag && <img src={gift} alt="" className={styles.logo_icon} />}
            {!soft.hasGiftBag && soft.editorRecommend && (
              <img src={reco} alt="" className={styles.logo_icon} />
            )}
          </div>
        </Link>
        <div className={styles.info}>
          <Link
            className={styles.title}
            to={{
              pathname: `${CONTEXT}/adetail/${soft.packageName}/${
                soft.versionCode
              }/${soft.bizInfo || '{}'}`,
            }}
            onClick={() => {
              handleSoftCard(soft);
            }}
            title={soft.softName}
          >
            <div className={styles.info_container}>
              <div className={styles.title_info}>
                <div className={styles.title} title={soft.softName}>
                  {soft.softName}
                  <span className={styles.title_point}> - 手机版</span>
                </div>
                <div className={styles.table}>
                  {soft &&
                    soft.searchTag &&
                    soft.searchTag.map((item, i) => (
                      <img src={item.icon} key={i} alt={item.name || ''} title={item.tips || ''} />
                    ))}
                </div>
              </div>
              <div className={styles.desc} title={soft.introduction}>
                {soft.introduction}
                {/* 手机版可在电脑上直接安装 */}
              </div>
            </div>
          </Link>

          {soft.activityList && soft.activityList[0] && (
            <MyLink handleClick={handleClickAD} data={soft.activityList[0]}>
              <div className={styles.link}>
                <img src={soft.activityList[0].targetType === '5' ? sale : essence} alt="" />
                <div className={styles.ad}>{soft.activityList[0].activityDesc}</div>
                <div className={styles.ad_arrow} />
              </div>
            </MyLink>
          )}
        </div>

        <div>
          <div className={styles.size}>
            <div className={styles.size_desc}>{soft.installFileSize}</div>
            <div className={styles.size_download}>{soft.downloadCount}安装</div>
          </div>
        </div>
        <div className={styles.score}>
          <div className={styles.score_detail}>
            <div className={styles.score_icon}>
              <Rate score={(Number(soft.score) / 20).toFixed(1)} />
            </div>
            <span className={styles.val}>{(Number(soft.score) / 20).toFixed(1)} </span>
          </div>
          <div className={styles.score_count}>{soft.commentUserCount}人打分</div>
        </div>

        <div
          className={styles.opt_div}
          onClick={() => {
            handleSoftBtn(soft);
          }}
        >
          <AButton
            soft={soft}
            info={{
              className: styles.soft_btn,
              className_busing: styles.soft_btn_busing,
              className_open: styles.soft_button_open,
              text: '安装',
            }}
            logInfo={logInfo}
          />
        </div>
      </div>
    </div>
  );
});
